'use client';

import React from 'react';
import { SectionStack } from '@/components/ui/SectionStack';
import { Hero } from './Hero';
import { MainSection } from './MainSection';
import { Footer } from './Footer';

export const EquityRelease = () => (
  <SectionStack>
    <Hero />
    <MainSection />
    <Footer />
  </SectionStack>
);
